<template>
  <div class="material">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem to="/host/index/home">首页</BreadcrumbItem>
          <BreadcrumbItem>管理</BreadcrumbItem>
          <BreadcrumbItem>关键字</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">关键字列表</div>
        <!-- <Input
          search
          placeholder="请输入关键字"
          v-model="search"
          @on-search="searchPro"
          style="width:230px;margin-top:20px;"
        /> -->
      </div>
      <div class="header-tool-box">
        <a class="htb-item" href="https://api.cmef.com.cn/api/Search/Export?agentId=CD4E8CEF-C6F7-4E72-9132-93161B9E8C43&clientType=2&api-version=1.0" target="_blank">
          <i class="icon iconfont icon-downLoad2"></i>
          <span>导出关键字统计</span>
        </a>
      </div>
    </div>
    <div class="header-tabs">
      <Tabs :animated="false" @on-click="switchBrand" v-model="showTabs">
        <TabPane label="小程序" name="1">
          <weapp></weapp>
        </TabPane>
        <TabPane label="网页" name="2">
          <pc></pc>
        </TabPane>
        <TabPane label="其他" name="3">
          <other></other>
        </TabPane>
        <!-- <TabPane label="商机拓展" name="3">
          <exhibitionBusinessExpand ref="exhibitionBusinessExpand" v-if="String(showTabs) === '3'" />
        </TabPane>-->
      </Tabs>
    </div>

    <!-- 修改展商置顶 -->
  </div>
</template>

<script>
import { mapActions } from "vuex";
import weapp from "./components/weapp.vue";
import pc from "./components/pc.vue";
import other from "./components/other.vue";
export default {
  name: "host-ex-list",
  data() {
    return {
      search: "",
      pageSize: 10,
      pageIndex: 1,
      totalCount: 0,
      showTabs: "1",
    };
  },
  components: {
    weapp,
    pc,
    other,
  },
  computed: {
    exhibitionInfo() {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    },
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      getSearch: "hostCommonModule/getSearch",
    }),
    async init() {},

    // changePage(e) {
    //   this.pageIndex = e;
    //   this.init();
    // },
    // changePageSize(e) {
    //   this.pageSize = e;
    //   this.init();
    // },
    switchBrand(name) {
      if (name === 1) {
        this.showTabs = 1;
      }
      if (name === 2) {
        this.showTabs = 2;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.header-tool-utils {
  margin-top: 20px;
  button {
    margin-right: 20px;
  }
}
.logo {
  width: 60px;
  height: 60px;
  display: inline-block;
}
/deep/ .resetModal {
  display: flex;
  align-items: center;
  justify-content: center;
  .ivu-modal {
    top: 0;
  }
  .ivu-modal-body {
    padding: 24px 0 0 16px;
  }
}
</style>
